import { jsx as e } from "react/jsx-runtime";
import t from "clsx";
//#region src/components/skeleton/Skeleton.tsx
var n = ({ shape: n = "text", width: r, height: i, animate: a = !0, className: o }) => /* @__PURE__ */ e("span", {
	"aria-hidden": "true",
	"data-pf-skeleton": !0,
	className: t("pf:relative pf:block pf:max-w-full pf:overflow-hidden pf:bg-soft-pearl-200", n === "circle" ? "pf:size-[32px] pf:rounded-full" : n === "block" ? "pf:h-[96px] pf:w-[160px] pf:rounded-sm" : "pf:h-[10px] pf:w-[160px] pf:rounded-xs", o),
	style: {
		width: r,
		height: i
	},
	children: a && /* @__PURE__ */ e("span", {
		"data-pf-shimmer": !0,
		className: "pf:absolute pf:inset-y-0 pf:left-[-60%] pf:w-[60%] pf:animate-[pf-skeleton-shimmer_1.5s_linear_infinite] pf:bg-linear-to-r pf:from-transparent pf:via-background/70 pf:to-transparent pf:motion-reduce:hidden"
	})
});
//#endregion
export { n as Skeleton };
